"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    ServiceProviderRole: {
        en: " Service Provider",
        es: "Proveedor de servicios",
    },
    ClientAdminRole: {
        en: "Administrator",
        es: "Administrador",
    },
    SukarneRole: {
        en: "Sukarne",
        es: "Sukarne",
    },
    MapRole: {
        en: "Map",
        es: "Mapa",
    },
    ReportRole: {
        en: "Report",
        es: "Reporte",
    },
    GroupRole: {
        en: "Groups",
        es: "Grupos",
    },
    CustomerSupportRole: {
        en: "Customer Support",
        es: "Servicio al cliente",
    },
    ViewAllDevicesRole: {
        en: "View All Units",
        es: "Ver todas las unidades",
    },
    NotificationAdminRole: {
        en: "Notification",
        es: "Notificaciones",
    },
    MaintenanceRole: {
        en: "Maintenance",
        es: "Mantenimiento",
    },
    CommandRole: {
        en: "Commands",
        es: "Comandos",
    },
    GeofencesRole: {
        en: "Geofences",
        es: "Geocercas",
    },
    PointsOfInterestsRole: {
        en: "Points Of Interests",
        es: "Puntos de Interés",
    },
    RouteMonitorRole: {
        en: "Route Monitor",
        es: "Monitor de rutas",
    },
    ManageDeviceInfoRole: {
        en: "Device info",
        es: "Ficha",
    },
    GoogleEarthRole: {
        en: "Google earth",
        es: "Google earth",
    },
    ShareExternalRole: {
        en: "Share Link",
        es: "Compartir enlace",
    },
    TemperatureReportRole: {
        en: "Temperature",
        es: "Temperatura",
    },
    GeofencesReportRole: {
        en: "Geofences",
        es: "Geocercas",
    },
    CameraReportRole: {
        en: "Photo Report",
        es: "Reporte de Fotos",
    },
    MaintenanceReportRole: {
        en: "Maintenance",
        es: "Mantenimiento",
    },
    FuelReportRole: {
        en: "Fuel",
        es: "Combustible",
    },
    CommandReportRole: {
        en: "Command Report",
        es: "Reporten de Comandos",
    },
    CommandsMassiveRole: {
        en: "Massive commands",
        es: "Comandos Masivos",
    },
    CommandsProgrammedRole: {
        en: "Programed commands",
        es: "Comandos Programados",
    },
    CommandsAutomaticRole: {
        en: "Automatic commands",
        es: "Comandos Automáticos",
    },
    ManageSensorsRole: {
        en: "Manage sensors",
        es: "Administrar sensores",
    },
    PointsOfInterestsReportRole: {
        en: "Points Of Interests",
        es: "Puntos de Interés",
    },
    LogInHistoryReportRole: {
        en: "Login History",
        es: "Historial de Accesos",
    },
    MonitorDeviceInfoRole: {
        en: "Unit information",
        es: "Información de unidad",
    },
    PromasaRole: {
        en: "Distance",
        es: "Distancia",
    },
    RouteUserRole: {
        en: "Route user",
        es: "Usuarios de ruta",
    },
    CAERole: {
        en: "Emergency Attention Center",
        es: "Centro de Atención a Emergencias",
    },
    PersonalTrackerRole: {
        en: "Personal tracker",
        es: "Rastreo personal",
    },
    WalmartServicesRole: {
        en: "Walmart Service",
        es: "Servicio de Walmart",
    },
    FuelControlRole: {
        en: "Fuel Control",
        es: "Control de Combustible",
    },
    ManageDriversRole: {
        en: "Manage Drivers",
        es: "Administrar conductores",
    },
    ManageUserRole: {
        en: "Manage Users",
        es: "Administrar usuarios",
    },
    IntegrationsRole: {
        en: "Integrations",
        es: "Integraciones",
    },
    TrustPilotManagementRole: {
        en: "Trust Pilot Management",
        es: "Administración de Trust Pilot",
    },
    SubscriptionManagementRole: {
        en: "Subscription Management",
        es: "Administración de Subscripciones",
    },
    CycleMonitoringRole: {
        en: "Cycle Monitoring",
        es: "Monitoreo de Ciclos",
    },
    DashboardRole: {
        en: "Dashboard",
        es: "Dashboard",
    },
    trackingRoutingRole: {
        en: "Tracking & Routing",
        es: "Rastreo y Ruteo",
    },
    trackingRole: {
        en: "Tracking",
        es: "Rastreo",
    },
    ManageUsersRole: {
        en: "Manage Users",
        es: "Administrar Usuarios",
    },
    BingSpeedingRole: {
        en: "Bing posted speed limit",
        es: "Limite de velocidad con Bing",
    },
    ImportTasksByCoordinatesRole: {
        en: "Task import by coordinates",
        es: "Importe de tareas por coordenadas",
    },
    RalentiReportRole: {
        en: "Ralenti",
        es: "Ralenti",
    },
    VideoCameraRole: {
        en: "Video Camera",
        es: "Camara de Video",
    },
    IdleReportRole: {
        en: "Idle",
        es: "Estacionado con Motor Encendido",
    },
    TaskRouteReportRole: {
        en: "Tasks Route",
        es: "Ruta de tareas",
    },
    LiveVideoRole: {
        en: "Live Video",
        es: "Video en Vivo",
    },
};
exports.default = translations;
